import {BaseWidget} from "./BaseWidget";

export class BooleanFieldWidget extends BaseWidget {
    createElement(style) {
        let widget = $(`<input type='checkbox' class="k-checkbox nama-checkbox k-checkbox-md" id="${this.elementId}" nid="${this.id}"/>`);
        let checkBoxLabel = $(`<label class="k-checkbox-label" ${style} for=${this.elementId}> </label>`);
        return widget.add(checkBoxLabel);
    }

    setValueInElement(value) {
        let checked = value === true || value === "true";
        this.findElement().prop("checked", checked);
    }

    readValueFromElement() {
        return this.findElement().prop("checked");
    }
}